module.exports = __webpack_public_path__ + "static/media/17_pol_0_86.2.6d820193.png";